import { render, staticRenderFns } from "./FilterDepartment.vue?vue&type=template&id=0f8dfb23&scoped=true&"
import script from "./FilterDepartment.vue?vue&type=script&lang=js&"
export * from "./FilterDepartment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8dfb23",
  null
  
)

export default component.exports